import { render, staticRenderFns } from "./BookLibraryWidget.vue?vue&type=template&id=3f8d12c2&scoped=true"
import script from "./BookLibraryWidget.vue?vue&type=script&lang=js"
export * from "./BookLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./BookLibraryWidget.vue?vue&type=style&index=0&id=3f8d12c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8d12c2",
  null
  
)

export default component.exports